import { useSaveQuestionnaire } from '@exam-room/graphql';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

import { QuestionnaireTemplateId } from '../../../../../hooks';
import { PATHS } from '../../../../constants';
import {
  QuestionnaireLongForm,
  QuestionnaireShortForm,
  QuestionnaireStandardForm,
} from '../questionnaire-form';
import { type QuestionnaireShortFormOutput } from '../questionnaire-form/questionnaire-short-form-schema';
import { type QuestionnaireStandardFormOutput } from '../questionnaire-form/questionnaire-standard-form-schema';

interface QuestionnaireSwitcherProps {
  templateId: QuestionnaireTemplateId | null;
}

export default function QuestionnaireSwitcher({
  templateId,
}: Readonly<QuestionnaireSwitcherProps>) {
  const { examCardId } = useParams();
  const navigate = useNavigate();
  const [saveQuestionnaire] = useSaveQuestionnaire();

  const handleSubmit = async (
    data: QuestionnaireStandardFormOutput | QuestionnaireShortFormOutput,
  ) => {
    if (!examCardId) throw new Error('Exam Card Id is not provided');
    await saveQuestionnaire({
      variables: {
        input: {
          examCardId,
          questionnaire: data,
        },
      },
      onCompleted: () => {
        navigate(generatePath(PATHS.Exam.Processing, { examCardId }));
      },
    });
  };

  switch (templateId) {
    case QuestionnaireTemplateId.TemplateA:
      return <QuestionnaireStandardForm onSubmit={handleSubmit} />;
    case QuestionnaireTemplateId.TemplateB:
      return <QuestionnaireLongForm onSubmit={handleSubmit} />;
    case QuestionnaireTemplateId.TemplateC:
      return <QuestionnaireShortForm onSubmit={handleSubmit} />;
    default:
      return null;
  }
}
